import { gql } from '@apollo/client';

export const SEND_ANSWER = gql`
    mutation sendAnswer($url: String!, $answer: String!) {
        sendAnswer(url: $url, answer: $answer) {
            status
        }
    }
`;
